import { render, staticRenderFns } from "./MyDocumentsSection.vue?vue&type=template&id=3e8864d6"
import script from "./MyDocumentsSection.vue?vue&type=script&lang=js"
export * from "./MyDocumentsSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports